import styled from 'styled-components'
import { widthResize, widthFull, heightFooter } from '../Resources/Theme'

export default styled.footer`
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  margin-left: ${props => props.resize ? widthResize : widthFull};
  transition: .5s;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${heightFooter};
  color: #6a776b;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  padding: 0 1rem 1rem;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`